import { atom } from "recoil";
import { ICarDetectionResponse } from "types/car-detection.d";

export const carDetectionState = atom({
  key: "carDetectionState",
  default: null as ICarDetectionResponse | null,
});
